import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import PannelBody from "../../../../fragments/PannelBody"

import classes from './SugestedPatients.module.css'
import SugestedPatientItem from "./SugestedPatientItem"

export default function SugestedPatients({readOnly}) {

    const activeCase = useSelector(state => state.case.activeCase)
    const [data, setData] = useState(null)

    

    useEffect(() => {
        if (activeCase && activeCase.police_report_occupants) {
            let arr = activeCase.police_report_occupants.filter(item => item.suggested_case_id)

            if (arr && arr.length > 0) {
                setData(arr)
            } else {
                setData(null)
            }
        }
    }, [activeCase])

    return <>
        
        {data && <PannelBody >
            <h4>Suggested Patients</h4>
            {data.length > 0 && data.map(item => (
                <SugestedPatientItem key={item.id} itemData={item} readOnly={readOnly} />
            ))}
        </PannelBody>}
    </>
}